// extracted by mini-css-extract-plugin
export default {"Academy":"academySection_Academy__Z6TRq","DarkEffect":"academySection_DarkEffect__vWmOY","Background":"academySection_Background__pRiFN"};